// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs-inline":"pdp-breadcrumbs_breadcrumbs-inline__nA0uE","shimmer-animation":"pdp-breadcrumbs_shimmer-animation__uZojv"};